/* eslint-disable */
import React, { Component } from 'react'
import styled from 'styled-components'
import notFoundImg from '../../static/images/404.jpg'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 13px;
`

const NoContent = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
`

class NoFound extends Component {
  componentDidMount() {
    const meta = document.createElement('meta')
    meta.name = 'prerender-status-code'
    meta.content = '404'
    document.getElementsByTagName('head')[0].appendChild(meta)
  }

  render() {
    return (
      <Wrapper>
        <NoContent>
          <img src={notFoundImg} />
        </NoContent>
      </Wrapper>
    )
  }
}

export default NoFound
